import { cloneDeep } from 'lodash';

import { initialState as initialTargetingState } from 'containers/TargetingPage/constants';
import {
  fetchTargetingSuccessActionHandler,
  addScreeningQuestionActionHandler,
  updateScreeningQuestionActionHandler,
  removeAllScreeningQuestionActionHandler,
} from 'containers/TargetingPage/reducer_utils';

class TargetingAPI {
  // using a private member here
  // to avoid accidental external mutations
  #state;

  constructor(fetchedTargeting = {}) {
    const defaultFetchedData = {
      data: fetchedTargeting,
    };
    const initializedState = fetchTargetingSuccessActionHandler(
      initialTargetingState,
      defaultFetchedData,
    );

    this.#state = initializedState;
  }

  addScreeningQuestion(screeningQuestion) {
    const updatedState = addScreeningQuestionActionHandler(this.#state, {
      payload: screeningQuestion,
    });

    this.#state = updatedState;
  }

  removeAllScreeningQuestion() {
    const updatedState = removeAllScreeningQuestionActionHandler(this.#state);

    this.#state = updatedState;
  }

  updateScreeningQuestion(screeningQuestion) {
    const updatedState = updateScreeningQuestionActionHandler(this.#state, {
      payload: { question: screeningQuestion },
    });

    this.#state = updatedState;
  }

  get state() {
    return cloneDeep(this.#state);
  }
}

export default TargetingAPI;
